import { FacetName, FilterInput, FilterName } from '../../__generated__/fed-graphql-types'
import { Facet } from '../../utils/search/search-results-util/search-results.util'
import { getFacetByFilter } from './facet-filter.map'

export interface Selected {
    values: string[]
    labels: string[]
}

export const createSelectedFilterMap = (filters: readonly FilterInput[], queryFacets: readonly Facet[] = []) => {
    const selectedMap = new Map<FilterName, Selected>()
    filters.forEach((filter) => {
        if (filter.selected && filter.selected.length) {
            selectedMap.set(filter.filter, {
                values: filter.selected as string[],
                labels: filter.selected as string[],
            })
        }
    })

    // Add in the labels for selected
    queryFacets.forEach((facet) => {
        facet.filters.forEach((filter) => {
            if (filter.selected && filter.selected.length) {
                const valueSet = selectedMap.get(filter.filter) || { labels: [], values: [] }
                const options = filter.options.filter((o) => filter.selected?.includes(o.value)) || []
                if (options.length) {
                    selectedMap.set(filter.filter, {
                        ...valueSet,
                        labels: options.map((o) => o.label),
                    })
                }
            }
        })
    })

    // Set only selected (aka matchesAll)
    queryFacets.forEach((facet) => {
        facet.filters
            .filter((filter) => filter.isOnlySelected && !selectedMap.get(filter.filter))
            .forEach((filter) => {
                const options = filter.options || []
                selectedMap.set(filter.filter, {
                    labels: options.map((o) => o.label),
                    values: options.map((o) => o.value as string),
                })
            })
    })

    return selectedMap
}

export const selectedFacetsFrom = (selectedFiltersMap: Map<FilterName, Selected>) => {
    const selectedFacetMap = new Set<FacetName>()
    for (const filter of selectedFiltersMap.keys()) {
        selectedFacetMap.add(getFacetByFilter(filter))
    }
    return selectedFacetMap
}
